import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BaseMapsUpdateModalContainer, type BaseMapsUpdateModalContainerProps,
} from './baseMapsUpdateModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BaseMapsUpdate: BaseMapsUpdateModalContainerProps;
  }
}
modalRenderer.register('BaseMapsUpdate', BaseMapsUpdateModalContainer);
